<article
  class="user-list-item"
  [attr.data-cy]="'user-list-item-id-' + (user$ | async)?._id">
  <div
    class="invite-checkbox"
    *ngIf="!(jobInPast$ | async)">
    <mat-checkbox
      color="primary"
      class="d-flex"
      [ngModel]="directInviteChecked$ | async"
      (ngModelChange)="
        directInviteChecked$.next($event); inviteCheckboxChange()
      "
      (click)="$event.stopPropagation()"
      data-cy="invite-checkbox"></mat-checkbox>
  </div>
  <div>
    <div class="possible-user-name">
      <span>{{ formatUserName() }}</span>
    </div>
    <div
      class="employee-customer"
      *ngIf="(user$ | async)?.isSharedPooler"
      [attr.data-cy]="
        'origin-customer-id-' + (user$ | async)?.sourceCustomer?.id
      ">
      {{
        "via " +
          (user$ | async)?.sourceCustomer?.displayName +
          ((user$ | async)?.sourceCustomer?.tariff
            ? " / " + (user$ | async)?.sourceCustomer?.tariff
            : "")
      }}
    </div>
    <div
      *ngIf="
            (user$ | async)?.customerInformation?.[(loggedInUser$ | async)?.customerId || ''] &&
            (user$ | async)?.customerInformation?.[(loggedInUser$ | async)?.customerId || '']?.poolerType
        ">
      <div class="custom-chip small-pill poolertype-pill mobile-only">
        {{(user$ | async)?.customerInformation?.[(loggedInUser$ | async)?.customerId || '']?.poolerType?.displayName | uppercase}}
      </div>
    </div>
  </div>
  <div
    *ngIf="
          (user$ | async)?.customerInformation?.[(loggedInUser$ | async)?.customerId || ''] &&
          (user$ | async)?.customerInformation?.[(loggedInUser$ | async)?.customerId || '']?.poolerType
      ">
    <div class="custom-chip small-pill poolertype-pill no-mobile">
      {{(user$ | async)?.customerInformation?.[(loggedInUser$ | async)?.customerId || '']?.poolerType?.displayName | uppercase}}
    </div>
  </div>
  <div class="flex-spacer"></div>
  <div>
    <div
      *ngIf="(inviteeNote$ | async) || (user$ | async)?.availabilityNote"
      class="availability-note text-m"
      data-cy="availability-note"
      #tooltip="matTooltip"
      (click)="$event.stopPropagation(); tooltip.toggle()"
      [matTooltip]="
        ((inviteeNote$ | async)
          ? (user$ | async)?.availabilityNote
            ? (inviteeNote$ | async) +
              '\n' +
              '\n' +
              (user$ | async)?.availabilityNote
            : (inviteeNote$ | async)
          : (user$ | async)?.availabilityNote) || ''
      "
      matTooltipPosition="above">
      <mat-icon
        class="size-20 text-icon-grey"
        svgIcon="note"></mat-icon>
      <span class="d-none d-md-block">
        {{ "hasNote" | i18n }}
      </span>
      <span class="d-block d-md-none">
        {{ "note" | i18n }}
      </span>
    </div>
    <app-previous-jobs-logs
      [user]="(user$ | async) ?? undefined"
      [departmentId]="(job$ | async)?.department?.id || ''">
    </app-previous-jobs-logs>
    <ng-container
      *ngIf="(loggedInUser$ | async)?.role === roleEnum.DISPO && (user$ | async)?.customerInformation?.[(loggedInUser$ | async)?.customerId || '']?.monthlyHours">
      <app-monthly-working-hours
        [user]="(user$ | async) ?? undefined"
        [customerId]="(loggedInUser$ | async)?.customerId || ''"
        [jobDate]="(job$ | async)?.date || ''">
      </app-monthly-working-hours>
    </ng-container>
    <div
      *ngIf="!(user$ | async)?.restStatus?.hasRested"
      class="rest-warning text-error"
      #restWarningTooltip="matTooltip"
      (click)="$event.stopPropagation(); restWarningTooltip.toggle()"
      matTooltipPosition="above"
      [matTooltip]="(user$ | async)?.restWarning || ''"
      data-cy="rest-warning">
      <mat-icon
        class="size-20 text-icon-error rest-warning-icon"
        svgIcon="bed"></mat-icon>
      <span class="d-none d-md-block"> {{ "restNotGuaranteed" | i18n }} </span>
      <span class="d-block d-md-none">
        {{ "restTime" | i18n }}
      </span>
    </div>
    <div
      *ngIf="(user$ | async)?.hasBlacklistedJobDepartment"
      class="department-blacklist-warning text-error"
      data-cy="department-blacklist-warning"
      #departmentBlacklistWarningTooltip="matTooltip"
      (click)="
        $event.stopPropagation(); departmentBlacklistWarningTooltip.toggle()
      "
      [matTooltip]="'departmentDeselectedByPooler' | i18n"
      matTooltipPosition="above">
      <mat-icon
        class="size-20 text-icon-error department-blacklist-warning-icon"
        svgIcon="alert-outline"></mat-icon>
      <span class="d-none d-md-block">
        {{ "departmentDeselected" | i18n }}
      </span>
      <span class="d-block d-md-none">
        {{ "department" | i18n }}
      </span>
    </div>
    <div
      *ngIf="isUndecided$ | async"
      class="unknown-availability-warning"
      data-cy="unknown-availability-warning">
      <mat-icon
        class="size-20"
        svgIcon="calendar-question"></mat-icon>
      <span class="d-none d-md-block">
        {{ "unknownAvailability" | i18n }}
      </span>
      <span class="d-block d-md-none">
        {{ "unknown" | i18n }}
      </span>
    </div>
    <div
      *ngIf="userCount$ | async"
      class="availableCount"
      data-cy="count-wrapper">
      <span data-cy="available-count">{{ countAvailableForJobs }}</span> /
      <span data-cy="job-count">{{ jobCount$ | async }}</span>
    </div>
  </div>
  <div class="direct-accept-checkbox">
    <mat-checkbox
      color="accent"
      class="d-flex"
      [ngModel]="directAcceptChecked$ | async"
      [disabled]="!canBookDirectly()"
      (ngModelChange)="
        directAcceptChecked$.next($event); directAcceptCheckboxChange()
      "
      (click)="$event.stopPropagation()"
      data-cy="direct-accept-checkbox"></mat-checkbox>
  </div>
</article>
<div
  class="collapse-wrapper"
  [class.collapsed]="!(animationShowDetails$ | async)">
  <div
    *ngIf="showDetails$ | async"
    class="collapse-child"
    [attr.data-cy]="'user-list-item-details-' + (user$ | async)?._id">
    <user-list-item-details
      class="list-item-details"
      [noPadding]="true"
      [user]="(user$ | async) ?? undefined"></user-list-item-details>
  </div>
</div>
